/* @flow */
import React from 'react';
import classNames from 'classnames';
import { Button, Form } from 'antd';
import styles from './SubmitButton.module.pcss';

const FormItem = Form.Item;

type Props = {
  className?: string,
  tailFormItemLayout?: Object,
  name: string,
};

const SubmitButton = ({ className, tailFormItemLayout, name, ...rest }: Props) => {
  const clsString = classNames(styles.submit, className);
  return (
    <FormItem {...tailFormItemLayout}>
      <Button {...rest} size="large" className={clsString} type="primary" htmlType="submit">
        {name}
      </Button>
    </FormItem>
  );
};

SubmitButton.defaultProps = {
  className: '',
  tailFormItemLayout: {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 24 },
      md: { span: 24 },
      lg: { span: 24 },
      xl: { span: 24 },
      xxl: { span: 24 },
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 24 },
      md: { span: 24 },
      lg: { span: 24 },
      xl: { span: 24 },
      xxl: { span: 24 },
    },
  },
};

export default SubmitButton;
